import React, { useEffect, useState } from 'react';
import "./LocationModal.css";
import close from "../../../../../../../../assets/close.svg";
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../../config';
import CollapseComponent from '../../../../../../../../Util/CollapseComponent/CollapseComponent';
import { messages } from '../../../../../../../../messages';
import SimpleBarReact from "simplebar-react";
import { faExclamationTriangle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LocationModal(props) {
	const [type, setType] = useState('view');
	const [locationTitle, setLocationTitle] = useState(null);
	const [locationId, setLocationId] = useState(null);
	const [editMode, setEditMode] = useState(false);
	const [deleteLoc, setEditDeleteLoc] = useState([]);

	/*** closes modal *****/
	const closeModal = (data = null) => {
		if (props.closeModal) {
			props.closeModal(data);
		}
	}

	/**** Sets title for edit location/field *****/
	const editLocation = (e) => {
		setLocationTitle(e);
	}

	const deleteLocation = () => {
		axiosApi.delete(`${config.apiUrl}/locations`, {
			data: {
				delete_ids: deleteLoc,
			},
		}).then(() => {
			setEditDeleteLoc([]);
			setEditMode(false);
		}).catch((err) => {
			console.error(err);
		});
	}

	const setIdToDelete = (data) => {
		setEditDeleteLoc(prev => {
			let loc_id = [...prev];
			const idx = loc_id.findIndex((id) => (id === data.id) && !data.checked);
			if (idx >= 0) {
				loc_id.splice(idx, 1);
			} else {
				if (data.checked && (loc_id).indexOf(data.id) === -1) {
					loc_id.push(data.id);
				}
			}
			return loc_id;
		});
	}
	useEffect(() => {
		if (props.type && props.type === 'Modify') {
			setType('modify');
		}
	}, [props.type])
	return <>
		<div className="modal LocationModal">
			<div className="modal-header">
				<h2>
					{
						editMode ? 'Warning'
							: (function () {
								if (locationTitle) {
									return (
										locationTitle.type === 'location' ? locationTitle.title
											: `Edit Field - ${locationTitle.title}`
									);
								} else {
									return (
										type === 'view' ? 'Edit Locations and Fields'
											: type === 'modify' ? 'Modify Locations'
												: type === 'add' ? 'Add Location'
													: type === 'add_field' ? 'Add Field'
														: 'N/A'
									);
								}
							})()
					}
				</h2>
				{
					type === 'view' && !editMode &&
					<p>
						Select a location or&nbsp;
						<span onClick={
							(e) => {
								e.preventDefault();
								setType('modify');
							}
						}
						>Add/Modify Locations
						</span>
					</p>
				}
				{
					(function () {
						if (type === 'modify') {
							if (locationTitle) {
								return <>
									<p>Select a {locationTitle.type === 'location' ? 'field' : 'location'} or&nbsp;
										<span onClick={(e) => {
											e.preventDefault();
											setLocationTitle(null);
											setType(locationTitle.type === 'location' ? 'add_field' : 'add');
										}}>Add New {locationTitle.type === 'location' ? 'Field' : 'Location'}
										</span>
									</p>
								</>
							}
							return <>
								<p>Select a location or&nbsp;
									<span onClick={(e) => {
										e.preventDefault();
										setType('add');
									}}>Add New Location
									</span>
								</p>
							</>
						}
					})()
				}
				{
					type === 'view' && !editMode ?
					'' : ''
						// <span onClick={() => deleteLoc?.length && setEditMode(true)} className={`delete${!deleteLoc?.length ? ' disable' : ''}`}>
						// 	<FontAwesomeIcon icon={faTrashAlt} className='location-delete' />
						// </span> : ''
				}
				<span className="close" onClick={closeModal}>
					<img src={close} alt='close-icon' />
				</span>
			</div>
			{
				!editMode ? <ModifyViewLocation
					state={props && props.type === 'Modify' ? 'Modify' : ''}
					type={type}
					setType={(e) => setType(e)}
					closeModal={(e) => closeModal(e)}
					editLocation={editLocation}
					locationField={(id) => setLocationId(id)}
					locationId={locationId}
					selectedData={Array.isArray(props.selectedData) ? props.selectedData : []}
					emitDataToDelete={(data) => data && setIdToDelete(data)}
				/>
					: <div className="warning-message-field">
						<FontAwesomeIcon icon={faExclamationTriangle} className='warning-icon' />
						<p>Are you sure you want to delete these locations, associated fields also get deleted?</p>
					</div>
			}
			{
				editMode &&
				<div className="modal-footer d-flex">
					<button className="cancel-btn" onClick={() => setEditMode(false)}>Cancel</button>
					<button type="submit" onClick={() => deleteLocation()}>Confirm</button>
				</div>
			}
		</div>
	</>
}

function ModifyLocationComponent(props) {
	const [locationId, setLocationId] = useState(null);
	const [location, setLocation] = useState(null);
	const [locationTitle, setLocationTitle] = useState('');

	useEffect(() => {
		setLocationId(props.data || null);
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (locationId) {
			getLocationDetail();
		}
		//eslint-disable-next-line
	}, [locationId])

	const updateLocationOrField = () => {
		axiosApi.put(`${config.apiUrl}/locations/${locationId}`, {
			title: locationTitle,
			parent_id: 0,
		}).then(() => {
			if (props.exitEditLocation) {
				props.exitEditLocation();
			}
		}).catch((err) => {
			console.error(err);
		});
	}

	const getLocationDetail = () => {
		axiosApi.get(`${config.apiUrl}/locations/${locationId}`).then((resp) => {
			if (resp && resp.data && resp.data.data) {
				setLocationTitle(resp.data.data.title || '')
				setLocation(resp.data.data);
			}
		}).catch((err) => {
			console.error(err);
		});
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		updateLocationOrField();
	}

	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className="modal-body Add-Modify">
					<div className="inner-blk">
						<div className="modify-content">
							<div className="input-field">
								<label className="label-color-xFKxiiR">Location Title</label>
								<input className="primary-input" type="text" value={locationTitle} onChange={(e) => setLocationTitle(e.target.value)} />
							</div>
						</div>
						<div className="input-field">
							<label className="label-color-xFKxiiR">Fields</label>
						</div>
						<SimpleBarReact style={{ maxHeight: 400 }}>
							<div className="modifyBlk-inner">
								{
									location &&
										location.fields &&
										location.fields.length ?
										location.fields.map((field) => (
											<div onClick={
												() => {
													props.setType && props.setType('edit_field');
													props.selectedField && props.selectedField(field);
												}
											} className="inner-blk" style={{ cursor: 'pointer' }}>
												<div className="modify-header">
													<span>{field.title}</span>
													<span className="collapsible-arrow"></span>
												</div>
											</div>)
										)
										: <></>
								}
							</div>
						</SimpleBarReact>
					</div>
				</div>
				<div className="modal-footer d-flex">
					<button className="cancel-btn"
						onClick={() => {
							if (props.exitEditLocation) {
								props.exitEditLocation();
							}
						}}>Cancel</button>
					<button type="submit">Confirm</button>
				</div>
			</form>
		</>
	);
}

/***** Add Field/Location Pop up content *******/
function AddLocation(props) {
	const [location, setLocation] = useState('');
	const [formSubmited, setFormSubmited] = useState(false);

	useEffect(() => {
		setLocation(props.field || '');
	}, [props.field]);

	const addLocation = () => {
		axiosApi.post(`${config.apiUrl}/locations`, {
			title: location,
			parent_id: Number(props.locationId) || 0,
		}).then(() => {
			refresh();
		}).catch((err) => {
			console.error(err);
		});
	}

	const updateLocation = (id) => {
		axiosApi.put(`${config.apiUrl}/locations/${id}`, {
			title: location,
		}).then(() => {
			refresh();
		}).catch((err) => {
			console.error(err);
		});
	}

	const handleLocationChange = (e) => {
		e.preventDefault();
		setFormSubmited(true);
		if (!location.trim()) {
			return;
		}
		setFormSubmited(false);
		if (['add_field', 'add'].includes(props.type)) {
			addLocation();
		} else {
			if (props.type === 'edit_field') {
				updateLocation(props.locationId);
			}
		}
	}

	const refresh = () => {
		props.refreshList();
		props.setType('modify');
	}
	return (
		<>
			<form onSubmit={handleLocationChange}>
				<div className="modal-body editLocation">
					<div className="input-field">
						<label>{['edit_field', 'add_field'].includes(props.type) ? 'Field' : 'Location'} Name</label>
						<input
							className="primary-input"
							type="text"
							value={location}
							onChange={(e) => setLocation(e.target.value)}
						/>
						{
							formSubmited &&
							!location.trim() &&
							<span className="error error-location">{messages['location_error']}</span>
						}
					</div>
				</div>
				<div className="modal-footer d-flex">
					<button className="cancel-btn" onClick={(e) => {
						e.preventDefault();
						// if(props.type === 'modify') {
						// 	props.closeModal();
						// }
						refresh();
					}}>Cancel</button>
					<button type="submit">Confirm</button>
				</div>
			</form>
		</>
	);
}

// function AddField(props) {
// 	return (
// 		<>
// 			<div className="modal-body">
// 				<div className="modal-body editLocation">
// 					<div className="input-field">
// 						<label>Field Name</label>
// 						<input className="primary-input" type="text" />
// 					</div>
// 				</div>
// 			</div>
// 		</>
// 	);
// }

function ModifyViewLocation(props) {
	const [locationAndFields, setLocationAndFields] = useState([]);
	const [allLocations, setAllLocations] = useState([]);
	const [editLocation, setEditLocation] = useState(null);
	const [locationId, setLocationId] = useState(null);
	const [field, setField] = useState('');
	const [locField, setLocField] = useState([]);
	const [loader, setLoader] = useState(true)

	useEffect(() => {
		getLocationAndFields();
		setLocationId(props.locationId || null);
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (!editLocation) {
			props.editLocation(null);
			props.locationField(null);
			setLocationAndFields([]);
			setAllLocations([]);
		} else {
			props.editLocation({ type: 'location', title: editLocation.title });
			props.locationField(editLocation.id);
		}
		//eslint-disable-next-line
	}, [editLocation]);

	useEffect(() => {
		if (!locationAndFields?.length && !allLocations?.length) {
			getLocationAndFields();
		}
		//eslint-disable-next-line
	}, [locationAndFields, allLocations]);

	useEffect(() => {
		if (['add', 'add_field'].includes(props.type)) {
			setField('');
		}
	}, [props.type]);

	function getLocationAndFields() {
		setLoader(true);
		axiosApi.get(`${config.apiUrl}/locations`)
			.then((resp) => {
				if (resp.data &&
					resp.data.data &&
					resp.data.data.length) {
					let locationsWithFields = {};
					if (Array.isArray(props.selectedData)) {
						props.selectedData.forEach(obj => {
							locationsWithFields[obj.location.id] = obj.fields.filter(f => f && f.id).map(f => f.id);
						});
					}
					if (Array.isArray(resp.data.data)) {
						const locFields_ = []
						resp.data.data.forEach(loc => {
							if (!!locationsWithFields[loc.id]) {
								const loc_ = {
									location: {
										id: loc.id,
										title: loc.title,
									},
									fields: []
								};
								loc.checked = true;
								if (Array.isArray(loc.fields)) {
									loc.fields.forEach(field => {
										if (locationsWithFields[loc.id].includes(field.id)) {
											field['checked'] = true;
											loc_.fields.push({
												id: field.id,
												title: field.title,
											});
										} else {
											field['checked'] = false;
										}
									});
								}
								locFields_.push(loc_);
							}
						});
						setLocField(locFields_);
					}
					setLocationAndFields(resp.data.data);
					setAllLocations(resp.data.data);
					if (editLocation) {
						props.editLocation({ type: 'location', title: editLocation.title });
						props.locationField(editLocation.id);
					}
				}
				setLoader(false);
			})
			.catch((err) => {
				console.error(err);
				setLoader(false);
			});
	}

	const searchLocation = (search) => {
		let locations = [...allLocations];
		if (search) {
			locations = locations.filter((s) => (s.title || '').trim().toLowerCase().includes(search));
		}

		setLocationAndFields(locations);
	}

	const selectedLocation = (data) => {
		if (data) {
			setEditLocation(data);
		}
	}

	const handleFieldsSelect = (x) => {
		if (x && x.location && x.location.id) {
			const locFields_ = [...locField];
			const idx = locFields_.findIndex(field => field.location.id === x.location.id);
			if (idx >= 0) {
				if (x.fields && x.fields.length) {
					locFields_.splice(idx, 1, x);
				} else {
					locFields_.splice(idx, 1);
				}
			} else {
				if (x.fields && x.fields.length) {
					locFields_.push(x);
				}
			}
			setLocField(locFields_);
		}
	}

	const setDeleteId = (data) => {
		if (props.emitDataToDelete) {
			props.emitDataToDelete(data);
		}
	}

	return (
		<>
			{/* min-height */}
			<div className={`modal-body ${['modify', 'view'].includes(props.type) ? ' minh-350 modal-body-seasons' : ''}`}>
				{!editLocation && props.type !== 'add' && <div className="input-blk">
					<input type="text" placeholder="Search Location" onChange={(e) => searchLocation((e.target.value).trim().toLowerCase())}  />
				</div>}
				{
					(function () {
						if (editLocation && !['add_field', 'edit_field'].includes(props.type)) {
							return (
								<ModifyLocationComponent
									data={editLocation.id}
									setType={(e) => props.setType(e)}
									exitEditLocation={() => setEditLocation(null)}
									selectedField={(field) => {
										setField(field);
										props.editLocation({ type: 'field', title: field.title });
									}}
								/>
							)
						} else {
							if (['add', 'add_field', 'edit_field'].includes(props.type)) {
								return (
									<AddLocation
										refreshList={() => { setLocationAndFields([]); setAllLocations([]); }}
										type={props.type}
										setType={(e) => props.setType(e)}
										locationId={
											props.type === 'edit_field' ? field.id
												: ((editLocation && editLocation.id) || null)
										}
										field={field && field.title ? field.title : null}
									/>
								)
							} else {
								if (locationAndFields && locationAndFields.length) {
									return <>
										<SimpleBarReact style={{ maxHeight: 400 }}>
											{locationAndFields.map((location) => (
												<CollapseComponent
													emitSelectionForDelete={(data) => setDeleteId(data)}
													data={location}
													selector="title"
													expandKey="fields"
													expandSelector="title"
													key={`${location.id}-location-${props.type}`}
													type={props.type}
													closeModal={() => props.closeModal()}
													selectedLocation={selectedLocation}
													locationId={locationId}
													emitLocationsFields={(location_fields) => handleFieldsSelect(location_fields)}
												/>
											))
											}
										</SimpleBarReact>
									</>

								} else {
									return (!loader && <div className="noSeason">No Record Found</div>);
								}
							}
						}
					}())
				}
			</div>
			{
				!editLocation && ['view', 'modify'].includes(props.type) &&
				<div className="modal-footer d-flex">
					{
						['modify', 'view'].includes(props.type) &&
						<button className="cancel-btn"
							onClick={
								() => {
									if (props.closeModal && props.type === 'view') {
										props.closeModal()
									} else if (props && props.state === 'Modify') {
										props.closeModal();
									}
									else {
										props.setType('view');
									}
								}
							}
						>Cancel</button>
					}
					<button
						type="submit"
						onClick={
							() => {
								if (props.type === 'view') {
									props.closeModal({ type: 'location', data: locField });
								} else {
									props.setType('view')
								}
							}
						}
					>Confirm</button>
				</div>
			}
		</>
	);
}